export default __webpack_public_path__ + "static/media/LTO_E.75681232.svg";